export const API = {
  URL: 'https://apw.alpura.com:8243/',
};
 
export const environment = {
  production: true,
  regionesrecoleccion: API.URL + 'nid/v1/',
  relacionespago: API.URL + 'lcq/v1/',
  conceptos: API.URL + 'lcq/v1/',
  controlCompania: API.URL + 'lcq/v1/',
  tipoDesvio: API.URL + 'lcq/v1/',
  veterinarios: API.URL + 'lcq/v1/',
  collectionMovement: API.URL + 'lcq/v1/',
  movementRoute: API.URL + 'neo/v1/',
  rutas: API.URL + 'lcq/v1/',
  tanques: API.URL + 'lcq/v1/',
  companiaTransportistas: API.URL + 'lcq/v1/',
  movimientosControles: API.URL + 'lcq/v1/',
  premiosProductividad: API.URL + 'lcq/v1/',
  compensacionLogistica: API.URL + 'lcq/v1/',
  sucursales: API.URL + 'lcq/v1/',
  plantas: API.URL + 'lcq/v1/',
  bancos: API.URL + 'lcq/v1/',
  regiones: API.URL + 'lcq/v1/',
  maestroSocios: API.URL + 'lcq/v1/',
  log: API.URL + 'oll/v1/',
  partner: API.URL + 'ooc/v1/',
  otoscat: API.URL + 'goa/v1/',
  useraccess: API.URL + 'sqi/v1/',
  lotes: API.URL + 'ivi/v1/',
  liquidaciones: API.URL + 'ple/v1/',
  precioClaseA: API.URL + 'lll/v1/',
  utlieria: API.URL + 'gdoctos/v1/',
  searchComponent: API.URL + 'mntopc/v1/price-valid-com/searchComponent',
  searchSocioAndComponent: API.URL + 'mntopc/v1/price-valid-com/searchSocioAndComponent',
  priceValidComPutComponent: API.URL + 'mntopc/v1/price-valid-com/putComponent',
  consultaPlantas: API.URL + 'lcq/v1/v1/facilities-maintenance/getFacilitiesList',
  consultaXEstado: API.URL + 'dle/v1/liquidacion/consultaLiquidacionEstado',
  consultaDatosReporte: API.URL + 'cql/v1/collectionReport/collectionMilk',
  cierreSemanal: API.URL + 'csem/v1/cierreSem/cierreSemana',
  getInfoCierreSem: API.URL + 'csem/v1/cierreSem/validar/socio/',
  getInfoCierreSemFac: API.URL + 'csem/v1/cierreSem/validar/',
  consultaDatosReporteUltDia: API.URL + 'cql/v1/collectionReport/milkTransitLastDay',
  searchRutaByControl: API.URL + 'eec/v1/api/getCorreccion',
  recoleccionDesglose: API.URL + 'cen/v1/desglose/proveedores',
  buildExcel: API.URL + 'gdoctos/v1/build-excel/liquidacionProveedor',
  consultaDatosReporteUltDias: API.URL + 'lii/v1/milkTransitLastDays/datosReporte',
  guardaCambiosRuta: API.URL + 'eec/v1/api/updateCorreccion',
  searchDatosExcelFiltro: API.URL + 'mntopc/v1/price-valid-com/searchSocioAndComponentExcel',
  mandarCargaMasiva: API.URL + 'mntopc/v1/price-valid-com/cargaMasiva',
  cargaMasiva: API.URL + 'mntopc/v1/price-valid-com/cargaMasiva',
  priceValidComPostComponent: API.URL + 'mntopc/v1/price-valid-com/postComponent',
  priceValidComDelComponent: API.URL + 'mntopc/v1/price-valid-com/deleteComponent',
  literShareListAll: API.URL + 'ntq/v1/literShare/listAll',
  literShare: API.URL + 'ntq/v1/literShare/',
  catShareConsultaSocio: API.URL + 'otn/v1/catShare/consultaSocio',
  catShare: API.URL + 'otn/v1/catShare/',
  cargaMasivaCatShare: API.URL + 'otn/v1/catShare/cargaMasiva',
  exportCatShare: API.URL + 'otn/v1/catShare/exportaAciones',
  deleteAccion: API.URL + 'otn/v1/catShare/deleteAccion',
  contractGet: API.URL + 'imq/v1/contract/getContrato',
  contractAggregate: API.URL + 'imq/v1/contract/aggregateContrato',
  contractUpdate: API.URL + 'imq/v1/contract/updateContrato',
  cargaMasivaContract: API.URL + 'imq/v1/contract/cargaMasivaContract',
  deleteContract: API.URL + 'imq/v1/contract/deleteContrato',
  limitDayGetSocio: API.URL + 'mnn/v1/limitDay/obtienePromedio',
  limitDayAggregateSocio: API.URL + 'mnn/v1/limitDay/aggregateSocio',
  limitDayUpdateSocio: API.URL + 'mnn/v1/limitDay/updateSocio',
  limitByWeek: API.URL + 'mnn/v1/limitDay/obtener/topes-semana',
  updateTopesClase: API.URL + 'mnn/v1/limitDay/actualizacion/topesClase',
  weekCompriceSocioSemana: API.URL + 'roi/v1/weekComprice/socioSemana',
  weekCompricePrecioFijo: API.URL + 'roi/v1/weekComprice/precioFijo',
  weekComprice: API.URL + 'roi/v1/weekComprice/',
  fixedPriceValidFijoVigencia: API.URL + 'smp/v1/fixedPriceValid/fijoVigencia',
  fixedPriceValidFijoVigenciaExcel: API.URL + 'smp/v1/fixedPriceValid/fijoVigenciaExcel',
  fixedPriceValid: API.URL + 'smp/v1/fixedPriceValid/',
  fixedPriceValidCreated: API.URL + 'smp/v1/fixedPriceValid/creaFijoVigencia',
  weekFixedPriceFijoSemana: API.URL + 'dpo/v1/weekFixedPrice/fijoSemana',
  weekFixedPrice: API.URL + 'dpo/v1/weekFixedPrice',
  catUserControl: API.URL + 'cle/v1/catUserControl/',
  catResourceRol: API.URL + 'cle/v1/catResourceRol/',
  catResources: API.URL + 'cle/v1/catResource/',
  catObtenerUsuario: API.URL + 'cle/v1/catUserControl/v1/usuario/consultar',
  catCreate: API.URL + 'goa/v1/valueset/Create',
  catUpdate: API.URL + 'goa/v1/valueset/Update',
  catGetById: API.URL + 'goa/v1/valueset/getById/',
  catGetValueSet: API.URL + 'goa/v1/valueset/getAll',
  catSearchSet: API.URL + 'goa/v1/valueset/getByName/',
  getSocio: API.URL + 'ooc/v1/partner/getPartnerById',
  getSocioNumber: API.URL + 'ooc/v1/partner/getPartnerByNumber',
  partnerList: API.URL + 'ooc/v1/partner/getPartnerList',
  partnerById: API.URL + 'ooc/v1/partner/getPartnerById/',
  partnerByFacility: API.URL + 'ooc/v1/partner/getPartnerListByFacility/',
  savePartner: API.URL + 'ooc/v1/partner/insertPartner',
  updatePartner: API.URL + 'ooc/v1/partner/updatePartner/',
  getPlants: API.URL + 'lcq/v1/plants',
  getZonasGeograficas: API.URL + 'goa/v1/valueset/getById/246',
  getTipoSocio: API.URL + 'goa/v1/valueset/getById/189',
  getGrupoAparceria: API.URL + 'goa/v1/valueset/getById/190',
  getRegionesRecoleccion: API.URL + 'nid/v1/catalogo/regionesrecoleccion',
  getListaGrupoArrendador: API.URL + 'goa/v1/valueset/getById/242',
  getTipoPersona: API.URL + 'goa/v1/valueset/getById/191',
  catRegion: API.URL + 'lcq/v1/v1/region-maintenance/getRegionList',
  bankAccountByPartner: API.URL + 'ooc/v1/bank-account/getBankAccountByPartner?idPartner=',
  bankAccountById: API.URL + 'ooc/v1/bank-account/getBankAccountById/',
  insertBankAccount: API.URL + 'ooc/v1/bank-account/insertBankAccount',
  updateBankAccount: API.URL + 'ooc/v1/bank-account/updateBankAccount',
  catBankList: API.URL + 'lcq/v1/v1/banks-maintenance/getBanksList',
  catRelacionPago: API.URL + 'lcq/v1/catalogo/relacionespago',
  catSucursalesBank: API.URL + 'lcq/v1/v1/branches/getBranchesList',
  catRegionesRecoleccion: API.URL + 'nid/v1/catalogo/regionesrecoleccion',
  catEstados: API.URL + 'ooc/v1/state/getStateList',
  catMunicipio: API.URL + 'ooc/v1/municipality/getMunicipalityBiCveEnt?cveEnt=',
  catRutasRecoleccion: API.URL + 'lcq/v1/v1/picking-routes/getPickingRoutesList',
  weeksByYear: API.URL + 'lcq/v1/fecha/getWeeksByYear',
  fechaByWeek: API.URL + 'lcq/v1/fecha/getFechaByWeek',
  fijoVigencia: API.URL + 'smp/v1/fixedPriceValid/fijoVigencia',
  consultaSocio: API.URL + 'otn/v1/catShare/consultaSocio',
  getContrato: API.URL + 'imq/v1/contract/getContrato',
  exportContrato: API.URL + 'imq/v1/contract/exportaContratos',
  obtenePromedio: API.URL + 'mntopc/v1/price-valid-com/obtienePromedio',
  obtenePromedioFijo: API.URL + 'smp/v1/fixedPriceValid/obtienePromedio',
  keyclok: 'https://hub-login-kc.alpura.com/auth',
  realm: 'LQL',
  client: 'lql',
  obtenerPrecios: API.URL + 'mntopc/v1/price-valid-com/v1/obtener-precios',
  obtenerPreciosFijoVig: API.URL + 'smp/v1/fixedPriceValid/v1/obtener-precios?fechaInicial=',
  hcmEmployees: 'http://172.108.18.171:17007/soa-infra/resources/ALP_HCM_CLOUD/TrueCredential/Employees/',
  obtenerByNControl: API.URL + 'cll/v1/mttoRecoleccion/getControlInterno?controlInterno=',
  actualizaReco: API.URL + 'cll/v1/mttoRecoleccion/updateAjusteRecoleccion',
  getIncidenciasInd: API.URL + 'ivi/v1/IncidenciasIndividual/getIncidencias/',
  saveIncidenciasInd: API.URL + 'ivi/v1/IncidenciasIndividual/insertIncidencias',
  updateIncidenciasInd: API.URL + 'ivi/v1/IncidenciasIndividual/updateIncidencias',
  getCurrentDate: API.URL + 'ivi/v1/IncidenciasIndividual/getCurrentDate',
  getCurrentWeek: API.URL + 'ivi/v1/IncidenciasIndividual/getCurrentWeek',
  litersCollected: API.URL + 'cql/v1/collectionReport/',
  insertaAjusteReco: API.URL + 'cod/v1/ajustes/insertAjusteRecoleccion',
  consultBySocAndFRecol: API.URL + 'cod/v1/ajustes/obtener/socio-frecol?',
  consultAjusteReco: API.URL + 'cod/v1/ajustes/getAjustesRecoleccionBySocio?',
  deleteAjusteReco: API.URL + 'cod/v1/ajustes/deleteDanaControl',
  mountLiterAmount: API.URL + 'cql/v1/collectionReport/',
  getRangeWeeks: API.URL + 'cql/v1/collectionReport/getRangeWeeks/',
  getConciliacionMensual: API.URL + 'cql/v1/collectionReport/milkTransitMonth',
  getmountLiterAmount: API.URL + 'cql/v1/collectionReport/mountLiterAmount',
  obtenerControlInterno: API.URL + 'smp/v1/fixedPriceValid/v1/obtener-precios?fechaInicial',
  collectionAccountant: API.URL + 'cql/v1/collectionReport/collectionAccountant',
  validaVigencia: API.URL + 'cle/v1/catUserControl/validaVigencia/',
  addSpecialLabel: API.URL + 'cue/v1/specialLabel/addSpecialLabel',
  controlesInternos: API.URL + 'rsu/v1/internControl/internControlCollection',
  controlesInternosPartner: API.URL + 'rsu/v1/internControl/getPartnersPlanta',
  controlesInternosTank: API.URL + 'rsu/v1/internControl/getTanksPartner',
  controlesInternosTrans: API.URL + 'rsu/v1/api/v1',
  transferenciaUnion: API.URL + 'tucre/v1/unionTransfer/unionTransferCollection',
  transferenciaUnionArchivos: API.URL + 'tucre/v1/unionTransfer/moveUnionTransferCollection',
  transferenciaUniond: API.URL + 'tucre/v1/unionTransfer/download',
  calculaLiquidacion: API.URL + 'dle/v1/liquidacion/calculaLiquidacionV2',
  relacionFacturas: API.URL + 'lql/v1/invoiceRelation/relationParner',
  extractFacturas: API.URL + 'aia/v1/invoiceInterface/runJob',
  findByControlInterno: API.URL + 'cue/v1/specialLabel/findByControlInterno?controlInterno',
  insertIncidenciasLote: API.URL + 'ivi/v1/IncidenciasIndividual/insertIncidenciasLote',
  deleteIncidenciasInd: API.URL + 'ivi/v1/IncidenciasIndividual/cancelaIncidencias',
  reversaLiquidacion: API.URL + 'irz/v1/mantenimientoLiquidacion/reversa',
  porConcepto: API.URL + 'nod/v1/datos',
  autorizaLiquidacion: API.URL + 'irz/v1/mantenimientoLiquidacion/autoriza',
  relacionPagoRepo: API.URL + 'irz/v1/mantenimientoLiquidacion/relacionPago',
  loyalityPrice: 'loyalityAward',
  fidelityAward: 'fidelityAward',
  desvioLeche: API.URL + 'lec/v1/catalogo/obtener/reporte/desvio-leche/v1',
  consultaResumen: API.URL + 'cql/v1/collectionReport/collectionSummary',
  obtenerSemanaCerrada: API.URL + 'dle/v1/liquidacion/obtener/semana-cerrada/v1',
  precioFijoVigencia: API.URL + 'smp/v1/fixedPriceValid/cargaMasiva',
  precioComponenteVigencia: API.URL + 'mntopc/v1/price-valid-com/cargaMasiva',
  BASE_URL: API.URL + 'lqr/v1/',
  CIERRE_DIARIO: API.URL + 'are/v1/',
  MILKO: API.URL + 'arn/v1',
  FORMULAS: API.URL + 'afl/v1/',
  ANALISISTANQUE: API.URL + 'upe/v1/',
  validarEstadoUsuario: API.URL + 'cle/v1/catUserControl/bloqueoLQL/',
  validarVigencia: API.URL + 'cle/v1/catUserControl/validaVigencia/',
  getAnalisisLeche: API.URL + 'gdoctos/v1/getDataFromDate/',
  petSocLiqCons: API.URL + 'psi/v1/liquidacionConsecutivo/general',
  getPartnersCalLiq: API.URL + 'psi/v1/consecutiveLiquidationProcess/getPartners',
  getPartnerDataCalLiq: API.URL + 'psi/v1/consecutiveLiquidationProcess/getDataForPartner',
  obtenerLitrosConciliacionPorFiltros: API.URL + 'cql/v1/collectionReport/milkTransitCollection',
  getDataFromDate: API.URL + 'gdoctos/v1/getDataFromDate/',
  obtenrLike: API.URL + 'goa/v1/valueset/getByNameLike/',
  buildExcelDocument: API.URL + 'gdoctos/v1/build-excel/',
  fechaByWeekAndYear: API.URL + 'gdoctos/v1/getDataFromDate/',
  fixedPriceValidChangePriority: API.URL + 'smp/v1/fixedPriceValid/cambiarPrioridad',
  fixedPriceDelete: API.URL + 'smp/v1/fixedPriceValid/',
  validarPlantaAutorizada: API.URL + 'csem/v1/cierreSem/validarPlantaAutorizada/',
  accionesTopes: API.URL + 'elq/v1/accionesTopes/actionsReport',
  priceClassA: 'priceClassA',
  concentradoMensual: API.URL + 'eqt/v1/concentrado-litros',
  capturaAnalisis: API.URL + 'lnq/v1',
  capturaAnalisisPias: API.URL + 'iaa/v1',
  comparativoRecoAna: API.URL + 'oei/v1',
  cargaColiformesLPC: API.URL + 'llm/v1',
  generacionEtiquetas: API.URL + 'sai/v1',
  relacionAnalisisFecha: API.URL + 'qaa/v1',
  reporteTrazabilidad: API.URL + 'loa/v1',
  coliformesLPC: API.URL + 'rfo/v1',
  direccionesSocios: API.URL + 'scc/v1',
  maestroSociosPecuarios: API.URL + 'isa/v1',
  ponderacionRuta: API.URL + 'eon/v1',
  indicesCaldiad: API.URL + 'dlq/v1',
};
